<template>
  <div class="country-com-wrap" ref="countryListWrap">
    <div class="country-value" @click="selectCountry">
      {{countryName}}
      <div class="icon">
        <span class="iconfont icon-down"></span>
      </div>
    </div>
    <div ref="countryList" class="country-list-scroll" v-show="showList">
      <ul class="country-list">
        <li class="country" v-for="(country, index) in countryList" :key="'country' + index" @click="selectCountryAction(country)">
          <div class="country-text">{{lang === 'zh-CN' ? country.countryName : lang === 'zh-TW' ? country.countryNameTw : country.countryNameUs}}</div>
          <span class="icon-selected iconfont" v-if="countryInfo.id === country.id"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Config from 'common/script/config.js'
export default {
  name: 'countryCom',
  props: ['lang'],
  data: function () {
    return {
      countryList: [],
      countryInfo: {},
      countryName: '',
      showList: false,
      language: ''
    }
  },
  created () {
    let lang = Config.cookieGet('lang')
    if (lang === 'en') {
      lang = 'en-US'
    }
    this.getCountryList(lang)
  },
  mounted () {
    document.addEventListener('click', e => {
      if (this.showList) {
        if (!this.$refs.countryListWrap.contains(e.target)) {
          this.showList = false
        }
      }
    })
  },
  watch: {
    lang: function (value) {
      if (value === 'zh-CN') {
        this.countryName = this.countryInfo.countryName
      } else if (value === 'zh-TW') {
        this.countryName = this.countryInfo.countryNameTw
      } else {
        this.countryName = this.countryInfo.countryNameUs
      }
    }
  },
  methods: {
    getCountryList: function (lang) {
      this.$http.get(Config.passportHost + '/public/country/code?type=' + lang).then((response) => {
        if (response.body.code === Config.R_CODE.SUCCESS) {
          this.countryList = response.body.body.countryList
          for (const item of this.countryList) {
            if (item.defaultCountry) {
              this.countryInfo = item
              this.$emit('input', this.countryInfo)
              if (this.lang === 'zh-CN') {
                this.countryName = this.countryInfo.countryName
              } else if (this.lang === 'zh-TW') {
                this.countryName = this.countryInfo.countryNameTw
              } else {
                this.countryName = this.countryInfo.countryNameUs
              }
            }
          }
        }
      })
    },
    selectCountry: function () {
      this.showList = !this.showList
    },
    selectCountryAction: function (country) {
      this.countryInfo = country
      this.showList = false
      this.$emit('input', this.countryInfo)
      if (this.lang === 'zh-CN') {
        this.countryName = this.countryInfo.countryName
      } else if (this.lang === 'zh-TW') {
        this.countryName = this.countryInfo.countryNameTw
      } else {
        this.countryName = this.countryInfo.countryNameUs
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.country-com-wrap
  width 3.05rem
  height 0.44rem
  background-color #f6f6f6
  position relative
  border-radius 0.04rem
  position relative
  .icon
    position absolute
    right 0.12rem
    top 50%
    transform translateY(-50%)
    font-size 0.1rem
    color #979797
  .country-value
    max-width 100%
    height 0.44rem
    line-height 0.44rem
    font-size 0.12rem
    color #adadad
    text-align center
  .country-list-scroll
    position absolute
    width 3.05rem
    height 2.25rem
    overflow-y scroll
    background-color #f6f6f6
    padding 0.05rem 0
    border-bottom-left-radius 0.04rem
    border-bottom-right-radius 0.04rem
    .country-list
      width 100%
      .country
        width 100%
        height 0.36rem
        background-color #f6f6f6
        border-radius 0.04rem
        position relative
        &:hover
          background-color #ededed
        .country-text
          max-width 100%
          height 0.44rem
          line-height 0.44rem
          font-size 0.12rem
          color #adadad
          text-align center
        .icon-selected
          position absolute
          right 0.12rem
          top 50%
          transform translateY(-50%)
          font-size 0.1rem
          color #979797
</style>



// WEBPACK FOOTER //
// countryCom.vue?57d853e0